module.exports = "/fonts/PT Root UI_Medium.ttf?588b7de1aac161679638ced9337bbe6f";